class FractionsSwitch extends HTMLElement {
    constructor() {
        super();
        this.onTabChange = this.onTabChange.bind(this);
    }

    connectedCallback() {
        this.tabs = this.querySelector('ui-tabs');
        this.tabs?.addEventListener('ui:tabchange', this.onTabChange);

        this.infoElements = this.querySelectorAll('svg[data-info]');
        this.graphDataElements = this.querySelectorAll('[data-graph-data]');
        this.newInfoElements = this.querySelectorAll('[data-new-info]');
        this.originalText = new Map();
        this.newInfoElements.forEach((el) => {
            this.originalText.set(el, el.textContent.trim());
        });

        const initialTab = this.tabs?.querySelector('[role="tab"][aria-selected="true"]')?.dataset?.value;
        if (initialTab != null) this.onTabChange({ detail: { value: initialTab } });
    }

    disconnectedCallback() {
        this.tabs?.removeEventListener('ui:tabchange', this.onTabChange);
    }

    onTabChange(e) {
        const value = e.detail?.value;
        if (value == null) return;

        const isTWOZERO = value === 'TWOZERO';
        const showInfo = isTWOZERO ? 'TWOZERO' : 'standard-whey';

        this.infoElements?.forEach((el) => {
            const match = el.getAttribute('data-info') === showInfo;
            if (match) el.removeAttribute('hidden');
            else el.setAttribute('hidden', '');
        });

        this.newInfoElements?.forEach((el) => {
            const newInfo = el.getAttribute('data-new-info');
            el.textContent = isTWOZERO && newInfo ? newInfo : (this.originalText.get(el) ?? el.textContent);
        });

        this.graphDataElements?.forEach((el) => {
            if (isTWOZERO) el.setAttribute('hidden', '');
            else el.removeAttribute('hidden');
        });
    }
}

customElements.define('fractions-switch', FractionsSwitch);
